import { getInactiveTime, getNextActiveTime, isScheduleActive } from 'utils/scheduling';

const findScheduleById = (schedules, scheduleId) =>
  schedules.find(scheduleEntry => Number(scheduleEntry.get('id')) === scheduleId);

const getSplashCandidates = branding => {
  if (!branding) return { defaultSplashPath: undefined, candidates: [] };

  const splashPathsBySchedule = branding.get('splash_paths_by_schedule');
  const candidates = splashPathsBySchedule
    ? splashPathsBySchedule
        .entrySeq()
        .map(([scheduleId, value]) => ({
          scheduleId: Number(scheduleId),
          path: value.get('path'),
          order: Number(value.get('order')),
        }))
        .toArray()
    : [];

  return {
    defaultSplashPath: branding.get('splash_default_path') || branding.get('splash_path'),
    candidates,
  };
};

export const getActiveSplashPath = ({ branding, schedules, currentTime }) => {
  const { defaultSplashPath, candidates } = getSplashCandidates(branding);
  if (!schedules || candidates.length === 0) return defaultSplashPath;

  let best;
  candidates.forEach(candidate => {
    const schedule = findScheduleById(schedules, candidate.scheduleId);
    if (!schedule || !isScheduleActive(schedule, currentTime)) return;

    if (!best || candidate.order < best.order) best = candidate;
  });

  return best ? best.path : defaultSplashPath;
};

export const getNextSplashChangeTime = ({ branding, schedules, currentTime }) => {
  const { candidates } = getSplashCandidates(branding);
  if (!schedules || candidates.length === 0) return null;

  const nowMs = currentTime.getTime();
  let nextTime = null;

  candidates.forEach(candidate => {
    const schedule = findScheduleById(schedules, candidate.scheduleId);
    if (!schedule) return;

    const isActive = isScheduleActive(schedule, currentTime);
    const candidateNextTime = isActive
      ? getInactiveTime(schedule, currentTime)
      : getNextActiveTime(schedule, currentTime);

    if (candidateNextTime > nowMs && (!nextTime || candidateNextTime < nextTime)) {
      nextTime = candidateNextTime;
    }
  });

  return nextTime;
};

export const getSplashImagePaths = branding => {
  const { defaultSplashPath, candidates } = getSplashCandidates(branding);
  return Array.from(
    new Set([defaultSplashPath, ...candidates.map(candidate => candidate.path)].filter(Boolean))
  );
};
